(function () {
    'use strict';

    angular
        .module('Lavpop-store.services')
        .service('OrderService', OrderService)

    /** @ngInject */
    function OrderService(HttpService) {
        const OrderService = {
            getAllByParameters: getAllByParameters,
            get: get,
            getAllStatus: getAllStatus,
            post: post
        };

        return OrderService;

        function getAllByParameters(params) {
            return HttpService.get('/orders', {
                params
            });
        }

        function get(orderId, personId, unitId) {
            let link = `${orderId}`;

            if (personId && unitId)
                link = link.concat(`/${personId}/${unitId}`);

            return HttpService.get(`/orders/${link}`);
        }

        function getAllStatus() {
            return HttpService.get('/orders/status');
        }

        function post(orderData) {
            return HttpService.post('/orders', orderData);
        }
    }
}());